import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const ComplianceInProgressIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.75 8.334a.75.75 0 0 1-.75.75H5.8a.75.75 0 0 1 0-1.5h1.45V5.033a.75.75 0 1 1 1.5 0zM3.174 4.359v3.275a5.31 5.31 0 0 0 2.669 4.606L8 13.478l2.158-1.238a5.31 5.31 0 0 0 2.668-4.606V4.359L8 2.511zm-1.5 3.275v-3.37c0-.564.348-1.07.875-1.272l4.964-1.9c.314-.12.66-.12.974 0l4.964 1.9c.527.202.875.708.875 1.272v3.37a6.81 6.81 0 0 1-3.422 5.907l-2.226 1.277c-.42.24-.936.24-1.356 0l-2.226-1.277a6.81 6.81 0 0 1-3.422-5.907"
      clipRule="evenodd"
    />
  </svg>
);
ComplianceInProgressIcon.id = 'ComplianceInProgressIcon';
ComplianceInProgressIcon.displayName = 'ComplianceInProgressIcon';
export default ComplianceInProgressIcon;
